/**
 * @generated SignedSource<<7e53bf2ab4b872c8ed4a4994ea962b47>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type DiscountDuration = "FIRST_ONLY" | "N_MONTHS" | "RECURRING" | "%future added value";
export type PlanSlug = "BANQUET" | "CHEFS_SPECIAL" | "DEGUSTER" | "GOURMET" | "TWOHDSC" | "%future added value";
export type ValidatePromotionalCodeQuery$variables = {
  code: string;
};
export type ValidatePromotionalCodeQuery$data = {
  readonly validatePromotionalCode: {
    readonly plans: ReadonlyArray<{
      readonly comingSoon: boolean | null;
      readonly discountDuration: DiscountDuration | null;
      readonly discountLabel: string | null;
      readonly durationMonths: number | null;
      readonly effectiveValueCents: number | null;
      readonly name: string;
      readonly slug: PlanSlug;
      readonly valueCents: number;
    }>;
    readonly valid: boolean;
  };
};
export type ValidatePromotionalCodeQuery = {
  response: ValidatePromotionalCodeQuery$data;
  variables: ValidatePromotionalCodeQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "code"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "code",
        "variableName": "code"
      }
    ],
    "concreteType": "ValidatePromotionalCodePayload",
    "kind": "LinkedField",
    "name": "validatePromotionalCode",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "valid",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "PromotionalPlan",
        "kind": "LinkedField",
        "name": "plans",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "slug",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "valueCents",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "comingSoon",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "effectiveValueCents",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "discountLabel",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "discountDuration",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "durationMonths",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ValidatePromotionalCodeQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ValidatePromotionalCodeQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "79c3a8b3cbe0360ac06bcc0d6f37366d",
    "id": null,
    "metadata": {},
    "name": "ValidatePromotionalCodeQuery",
    "operationKind": "query",
    "text": "query ValidatePromotionalCodeQuery(\n  $code: String!\n) {\n  validatePromotionalCode(code: $code) {\n    valid\n    plans {\n      slug\n      name\n      valueCents\n      comingSoon\n      effectiveValueCents\n      discountLabel\n      discountDuration\n      durationMonths\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "2b4c2eef7ea94149aaac8510ebd1c83d";

export default node;
